import reducer from "./reducer";
import rootSaga from "./sagas";
import { IAuthStore as store } from "./store";

export const authSagas = rootSaga;
export const authReducer = reducer;
export type IAuthStore = store;
